"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStorageService = void 0;
function get(key, fallback) {
    if (fallback === void 0) { fallback = ''; }
    try {
        return window.localStorage.getItem(key);
    }
    catch (_a) {
        return fallback;
    }
}
function set(key, value) {
    try {
        window.localStorage.setItem(key, value);
        return true;
    }
    catch (_a) {
        return false;
    }
}
function removeItem(key) {
    try {
        window.localStorage.removeItem(key);
        return true;
    }
    catch (error) {
        return false;
    }
}
exports.localStorageService = {
    get: get,
    set: set,
    removeItem: removeItem,
};
